// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"25d84549","91":"7a6e683b","336":"2cefba75","453":"8116e211","471":"77d49d59","639":"46059056","751":"8d4f9943","818":"15fcc7a4","978":"be0de5a1"}[chunkId] + ".chunk.js";
};